<template>
  <div id="trendsPage">
    <NavBar class="overflow-y-hidden"/>
    <v-main class="overflow-hidden">
      <div class="container-fluid">
        <div class="row no-gutters">
          <div class="col-auto pt-0 pl-0 ">
            <v-btn icon @click="$router.go(-1)">
              <i class="fa-solid fa-arrow-right fa-xl"></i></v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-10 col-md-6 card-bg mx-auto">
            <PostCard v-if="!postLoading" :item="post"/>
          </div>
        </div>

      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import PostCard from "@/components/PostCard";
import NavBar from "@/components/NavBar";

export default {
  name: "TrendDetail",
  metaInfo: {
    title: 'ایوان خانه- جزئیات',
  },
  components: {NavBar, PostCard},
  data: () => ({
    post: {},
    postLoading: true,
    showLoaderDialog: false,
  }),
  mounted() {
    this.getSpecialSocial()
  },
  methods: {
    getSpecialSocial() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorSocialNetworkID", this.$route.query.VendorSocialNetworkID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/SpecialSocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let postFiles = []
            postFiles.push({src: json.FileUrl, type: json.TypeStrucGallery})
            if (json.FileUrl2 !== null) {
              postFiles.push({src: json.FileUrl2, type: json.FileType2})
            }
            if (json.FileUrl3 !== null) {
              postFiles.push({src: json.FileUrl3, type: json.FileType3})
            }
            if (json.FileUrl4 !== null) {
              postFiles.push({src: json.FileUrl4, type: json.FileType4})
            }
            if (json.FileUrl5 !== null) {
              postFiles.push({src: json.FileUrl5, type: json.FileType5})
            }
            if (json.FileUrl6 !== null) {
              postFiles.push({src: json.FileUrl6, type: json.FileType6})
            }
            if (json.FileUrl7 !== null) {
              postFiles.push({src: json.FileUrl7, type: json.FileType7})
            }
            if (json.FileUrl8 !== null) {
              postFiles.push({src: json.FileUrl8, type: json.FileType8})
            }
            if (json.FileUrl9 !== null) {
              postFiles.push({src: json.FileUrl9, type: json.FileType9})
            }
            if (json.FileUrl10 !== null) {
              postFiles.push({src: json.FileUrl10, type: json.FileType10})
            }
            json.files = postFiles


            let allHashtags = this.$store.getters.getHashtags
            let selectedHashtags = json.SelectedHashTags
            let hashtags = []
            if (selectedHashtags !== null && selectedHashtags.length > 0) {
              for (let i = 0; i < selectedHashtags.length; i++) {
                hashtags.push(allHashtags.find(x => x.HashTagID === selectedHashtags[i]))
              }
            }
            json.hashtags = hashtags


            let products = this.$store.getters.getProductsList

            let relatedProducts = []
            let selectedProducts = json.SelectedProducts
            if (selectedProducts !== null) {
              for (let i = 0; i < selectedProducts.length; i++) {
                relatedProducts.push(products.find(x => x.VendorProductID === selectedProducts[i]))
              }
              for (let i = 0; i < relatedProducts.length; i++) {
                relatedProducts[i].tip = relatedProducts[i].VendorProductTipViewModels[0]
              }
            }


            json.relatedProducts = relatedProducts


            this.post = json;
            this.postLoading = false
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
